import axios from 'axios'
import router from '../router'

const state = {
  loading: true,
  email: '',
  code: '',
  invalidCode: false,
  validCode: false,
  endDate: '',
  orderId: '',
  paymentMethodId: '',
  items: []
}

const actions = {
  load ({
    commit,
    dispatch
  }, data) {
    commit('startLoading')
    axios.get('https://api.stl-vpn.ru/api/side-pricing').then(response => {
      commit('stopLoading')
      if (typeof response.data !== 'undefined') {
        commit('clean')
        response.data.forEach(function (item) {
          commit('create', item)
        })
      }
    }).catch(error => {
      console.log(error)
      commit('stopLoading', error)
    })
  },
  topUpCode ({
    dispatch,
    commit
  }, data) {
    router.push({ name: 'OrderVpn' })
  },
  makeOrder ({
    dispatch,
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      data.code = state.code
      data.email = state.email
      console.log(data)
      console.log(state)
      axios.get('https://api.stl-vpn.ru/free-kassa/create-order-a/' + state.orderId, { params: data }).then(response => {
        if (response.status === 200) {
          localStorage.promocodeId = response.data.id
          localStorage.orderId = response.data.order_id
          localStorage.promocode = response.data.promocode
          window.location.replace(response.data.payment_url)
        } else {
          router.push({ name: 'FailPaymant' })
        }
      }).catch(error => {
        console.log(error)
        router.push({ name: 'FailPaymant' })
      })
    })
  },
  getMehods ({
    dispatch,
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      data.code = state.code
      axios.get('https://api.stl-vpn.ru/free-kassa/currencies/' + data.id, { params: data }).then(response => {
        if (response.status === 200) {
          commit('setTariff', { email: data.email, id: data.id })
          commit('setMethods', response.data)
          router.push({ name: 'PaymentMethods' })
        } else {
          router.push({ name: 'FailPaymant' })
        }
      }).catch(error => {
        console.log(error)
      })
    })
  },
  buyCode ({
    commit,
    dispatch
  }, data) {
    commit('setCode', { code: '' })
    router.push({ name: 'OrderVpn' })
  },
  checkCode ({
    commit,
    dispatch
  }, code) {
    return new Promise((resolve, reject) => {
      commit('setCode', { code: code })
      axios.get('https://api.stl-vpn.ru/promocode/check-code', { params: { code: code } }).then(response => {
        if (response.status === 200) {
          commit('checkCode', {
            endDate: response.data.endDate,
            validCode: response.data.validCode
          })
        } else {
          commit('checkCode', { validCode: false })
        }
      }).catch(error => {
        console.log(error)
        commit('checkCode', { validCode: false })
      })
    })
  }
}

const mutations = {
  setCode (state, data) {
    state.code = data.code
  },
  setMethods (state, data) {
    state.paymentMethods = data
    console.log(state)
  },
  setTariff (state, data) {
    state.email = data.email
    state.orderId = data.id
    console.log(state)
  },
  checkCode (state, data) {
    if (data.validCode) {
      state.invalidCode = false
      state.validCode = true
      state.endDate = data.endDate
      router.push({ name: 'OrderVpnResult' })
    } else {
      state.invalidCode = true
      state.validCode = false
      state.endDate = ''
    }
    state.items = []
  },
  create (state, data) {
    data = {
      ...data,
      hide: false
    }
    state.items.push(data)
  },
  clean (state) {
    state.items = []
  },
  delete (state, data) {
    const index = state.items.findIndex(x => x.id === data.id)
    state.items[index].hide = true
  },
  restore (state, data) {
    const index = state.items.findIndex(x => x.id === data.id)
    state.items[index].hide = false
  },
  startLoading (state) {
    state.loading = true
  },
  stopLoading (state) {
    state.loading = false
  }

}

const getters = {
  priceItems (state) {
    return [...state.items].sort(function (a, b) {
      return a.count - b.count
    })
  },
  methodItems (state) {
    return [...state.paymentMethods]
  }
}

export const pricing = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
